import GlobalPageSupport = Infospeed.Services.ClassWeb.API.Contracts.COT.GlobalPageSupport;
import ContactUsItem = Infospeed.Services.ClassWeb.API.Contracts.COT.ContactUsItem;

import { Component, OnInit, Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, ActivatedRoute, RouterStateSnapshot } from '@angular/router';
import { CustomFabComponent } from '../../../widgets/custom-fab/custom-fab.component';
import { HarrowFooterService } from './harrow-footer.service';
import { BaseCotFormComponent } from '../../../components/base-cot-form.component';
import { Observable } from 'rxjs';
import { CommonNotificationService } from '../../../services/common-notification.service';
import { CommonUtilityService, BrowserTypes } from '../../../services/common-utility.service';
import { FooterService } from '../../../footer/footer.service';
import { FooterComponent } from '../../../footer/footer.component';

@Component({
    selector: 'harrow-footer',
    templateUrl: './harrow-footer.component.html',
    styleUrls: ['../../../widgets/widgets-custom-theme.scss', './harrow-footer.component.scss']
})
export class HarrowFooterComponent extends BaseCotFormComponent {
    footerInformation: string = "";
    copyrightText: string = "";
    siteAddress: string = "";
    contactUsItemArray: Array<ContactUsItem> = [];
    facebookLink: string = "";
    twitterLink: string = "";
    youtubeLink: string = "";
    linkedinLink: string = "";
    instagramLink: string = "";
    googlePlusLink: string = "";
    pinterestLink: string = "";
    footerInformations: string[] = [];
    isIEBrowser: boolean = false;

    constructor(private harrowFooterService: HarrowFooterService, private activatedRoute: ActivatedRoute, private notificationService: CommonNotificationService, private utilityService: CommonUtilityService) {
        super();
        this.harrowFooterService.getFooterData().takeUntil(this.emitUnsubscribe).subscribe(
            (data: GlobalPageSupport) => {
                // set footer information
                this.footerInformation = data.FooterInformation;
                this.copyrightText = data.CopyrightText;
                this.siteAddress = data.SiteAddress;
                this.contactUsItemArray = data.ContactUsItems;
                // set links
                this.facebookLink = this.harrowFooterService.facebookLink;
                this.twitterLink = this.harrowFooterService.twitterLink;
                this.youtubeLink = this.harrowFooterService.youtubeLink;
                this.linkedinLink = this.harrowFooterService.linkedinLink;
                this.instagramLink = this.harrowFooterService.instagramLink;
                this.googlePlusLink = this.harrowFooterService.googlePlusLink;
                this.pinterestLink = this.harrowFooterService.pinterestLink;
                // format footer
                this.footerInformations = this.utilityService.formatFooterInformation(this.footerInformation);
            }
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/customizations/harrow/footer/harrow-footer.component.ts